import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StrategyFilterState, TabsState } from './portfolio-filter.interface';
import { PortfolioProductType } from '@app/_shared/modules/portfolio-form/portfolio.enums';

@Injectable({
  providedIn: 'root'
})
export class PortfolioFilterService {
  productTypes = PortfolioProductType;
  public intialState: TabsState = {
    Deployed: {
      query: '',
      productType: this.productTypes.BOTH,
      sortBy: '',
      filter: ''
    },
    Shared: {
      query: '',
      productType: this.productTypes.BOTH,
      sortBy: '',
      filter: ''
    },
    Created: {
      query: '',
      productType: this.productTypes.BOTH,
      sortBy: '',
      filter: ''
    },
    Subscribed: {
      query: '',
      productType: this.productTypes.BOTH,
      sortBy: '',
      filter: ''
    },
    Saved: {
      query: '',
      productType: this.productTypes.BOTH,
      sortBy: '',
      filter: ''
    }
  }

  public filterState = new BehaviorSubject<TabsState>(this.intialState);
  
  constructor() { 
  }

  updateFilterState(state: StrategyFilterState, type: string) {
    this.filterState.value[type] = state;
    this.filterState.next(this.filterState.value);
  }

  getFilterState(): TabsState {
    return this.filterState.value;
  }
}
